import React from "react";
import ExcelJS from "exceljs";
import { CButton, CSpinner } from "@coreui/react";

function DownloadExcel(props) {
  const handlerClickDownloadButton = async () => {
    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("sheet1", {
      headerFooter: {
        firstHeader: "Hello Exceljs",
        firstFooter: "Hello World",
      },
    });

    const worksheet = workbook.getWorksheet("sheet1");

    const config = props.config ? props.config : { width: "30" };

    worksheet.columns = [
      ...props.columns.map((item) => {
        return { header: item.headerName, key: item.field, ...config };
      }),
    ];

    // Add header row
    worksheet.addRow({
      Total: "",
      Amount: "",
    });

    const data = props.rows;

    data.forEach((item, i) => {
      const row = worksheet.addRow({ no: i + 1, ...item });

      // Check if the 'deletedAt' field is not null
      if (item.deletedAt) {
        // Highlight the entire row in red
        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF0000" }, // Red color
          };
        });
      }
    });

    const uint8Array = await workbook.xlsx.writeBuffer();
    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    let fileName = props.dateFrom
      ? props.excelName + " Move Juice " + props.dateFrom + " sampai " + props.dateTo + ".xlsx"
      : props.excelName + " Move Juice.xlsx";
    a.href = url;
    a.download = fileName;
    a.click();
    a.remove();
  };

  return (
    <>
      <CButton
        onClick={(e) => handlerClickDownloadButton()}
        style={{ backgroundColor: "#4E5B97", border: "none" }}
        disabled={props.loading}
      >
        {props.loading ? <CSpinner color="primary" size="md" className="mr-3" /> : "Download"}
      </CButton>
    </>
  );
}

export default DownloadExcel;
